import { useMutation } from "react-query";
import { updateDocs } from "~/components/Forms/DealerPassportForm2/requests/updateDocs";

export default function useUpdateDocs() {
  return useMutation({
    mutationFn: ({ dealerId, data }: { dealerId: string; data: any }) =>
      updateDocs(dealerId, data),
  });
}
